<template>
<div class="chapter">
<div class="inner_page">
<div id="eve-of-warfare-8.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="h2">Other Books by Sylvia Day</p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"><strong>Contemporary Romance</strong></p>
<p class="body-center"> </p>
<p class="body-center">The Crossfire® Saga</p>
<p class="body-center"><em>Bared to You</em></p>
<p class="body-center"><em>Reflected in You</em></p>
<p class="body-center"><em>Entwined with You</em></p>
<p class="body-center"><em>Captivated by You</em></p>
<p class="body-center"><em>One with You</em></p>
<p class="body-center"> </p>
<p class="body-center">The Jax &amp; Gia Series</p>
<p class="body-center"><em>Afterburn/Aftershock</em></p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"><strong>Paranormal Romance</strong></p>
<p class="body-center"> </p>
<p class="body-center">The Renegade Angels Series</p>
<p class="body-center"><em>A Dark Kiss of Rapture</em></p>
<p class="body-center"><em>A Touch of Crimson</em></p>
<p class="body-center"><em>A Caress of Wings</em></p>
<p class="body-center"><em>A Hunger So Wild</em></p>
<p class="body-center"> </p>
<p class="body-center">The Dream Guardians Series</p>
<p class="body-center"><em>Pleasures of the Night</em></p>
<p class="body-center"><em>Heat of the Night</em></p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"><strong>Historical Romance</strong></p>
<p class="body-center"> </p>
<p class="body-center">The Georgian Series</p>
<p class="body-center"><em>Ask for It</em></p>
<p class="body-center"><em>Passion for the Game</em></p>
<p class="body-center"><em>A Passion for Him</em></p>
<p class="body-center"><em>Don’t Tempt Me</em></p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"><strong>Urban Fantasy</strong></p>
<p class="body-center"> </p>
<p class="body-center">The Marked Series</p>
<p class="body-center"><em>Eve of Darkness</em></p>
<p class="body-center"><em>Eve of Destruction</em></p>
<p class="body-center"><em>Eve of Chaos</em></p>
<p class="body-center"><em>Eve of Warfare</em></p>
<p class="body-center"><em>Eve of Sin City</em></p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"><strong>Single Titles</strong></p>
<p class="body-center"> </p>
<p class="body-center"><em>The Stranger I Married</em></p>
<p class="body-center"><em>Seven Years to Sin</em></p>
<p class="body-center"><em>Pride and Pleasure</em></p>
<p class="body-center"><em>In the Flesh</em></p>
<p class="body-center">Omnibus</p>
<p class="body-center"><em>Spellbound</em></p>
<p class="body-center"><em>Scandalous Liaisons</em></p>
<p class="body-center"><em>Love Affairs</em></p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"><strong>Novellas</strong></p>
<p class="body-center"> </p>
<p class="body-center">The Shadow Stalkers Miniseries</p>
<p class="body-center"><em>Razor’s Edge</em></p>
<p class="body-center"><em>Taking the Heat</em></p>
<p class="body-center"><em>Blood &amp; Roses</em></p>
<p class="body-center"><em>On Fire</em></p>
<p class="body-center"> </p>
<p class="body-center">The Carnal Thirst Series</p>
<p class="body-center"><em>Misled</em></p>
<p class="body-center"><em>Kiss of the Night</em></p>
<p class="body-center"> </p>
<p class="body-center"><em>Butterfly in Frost</em></p>
<p class="body-center"><em>All Revved Up</em></p>
<p class="body-center"><em>“Mischief and the Marquess” in Perfect Kisses</em></p>
<p class="body-center"><em>“Hard to Breathe” in Premiere</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eveofwarfarebooks.vue?486f7a1a